
import { commonfunc } from '~/mixin/common'
import { swiperBannerClick } from '~/mixin/swiperBannerClick'
import BannerMedia from '~/components/common/BannerMedia.vue'

export default {
  name: 'BannerContent',
  components: { BannerMedia },
  mixins: [commonfunc, swiperBannerClick],
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    /** 이미지 URL 리사이즈 suffix (CommonImage src에 붙음) */
    resizeSuffix: {
      type: String,
      default: ''
    },
    /**
     * band 타입 여부: true이면 헤드카피 줄바꿈을 제거 (띠배너 한 줄 표시용)
     * false이면 줄바꿈을 <br>로 변환
     */
    isBandType: {
      type: Boolean,
      default: false
    },
    /** 비디오 자동재생 여부 */
    videoAutoplay: {
      type: Boolean,
      default: false
    },
    /** true면 swiper lazy 모듈로 지연 로딩 (초기 노출 슬라이드 외) */
    useSwiperLazy: {
      type: Boolean,
      default: false
    },
    /** LCP 우선 로딩 여부 강제 지정. null이면 index===0을 기본값으로 사용 */
    priority: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    /** 첫 번째 슬라이드(LCP 요소)는 기본적으로 eager 로딩 */
    isPriority () {
      return this.priority !== null ? this.priority : this.index === 0
    },
    /** 언이스케이프된 이동 URL */
    bannerUrl () {
      return this.getBannerUrl(this.item)
    },
    /** 링크 유형에 따라 렌더링할 루트 태그 결정 */
    wrapperTag () {
      if (!this.bannerUrl) { return 'div' }
      return this.isBannerExternal(this.item) ? 'a' : 'nuxt-link'
    },
    /** wrapperTag에 맞는 속성 바인딩 */
    wrapperAttrs () {
      if (!this.bannerUrl) { return {} }
      if (this.isBannerExternal(this.item)) {
        return { href: this.bannerUrl, target: '_blank', rel: 'noopener' }
      }
      return { to: this.bannerUrl }
    },
    imageSrc () {
      return this.imgUrlMaker(this.item.pcomIconAtchFileUrl) + this.resizeSuffix
    },
    formattedHdcpy () {
      const text = this.item.hdcpy || ''
      const processed = this.isBandType ? text.replace(/\n/g, '') : text.replace(/\n/g, '<br>')
      return this._.unescape(processed)
    },
    formattedSubcpy () {
      const text = this.item.subcpy || ''
      const processed = this.isBandType ? text.replace(/\n/g, '') : text.replace(/\n/g, '<br>')
      return this._.unescape(processed)
    }
  }
}
